<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新建'"
      width="800px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="单号">
            <el-input v-model.trim="model.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="治具名称" prop="toolName">
            <el-input v-model="model.toolName" placeholder="请选择治具" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.toolSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="领用人" prop="receiverName">
            <el-input v-model="model.receiverName" placeholder="请选择领用人" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.receiverSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="领用时间">
            <el-date-picker
                v-model="model.receiveTime"
                style="width: 100%"
                type="datetime"
                placeholder="选择领用时间"
                value-format="yyyy-MM-dd HH:mm:ss"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="归还者">
            <el-input v-model="model.returnerName" placeholder="请选择归还者" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.returnerSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="归还时间">
            <el-date-picker
                v-model="model.returnTime"
                style="width: 100%"
                type="datetime"
                placeholder="选择完工时间"
                value-format="yyyy-MM-dd HH:mm:ss"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model.trim="model.note" type="textarea" autosize placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <tool-select ref="toolSelect" @select="selectTool"/>
    <user-select ref="receiverSelect" @select="selectReceiver"/>
    <user-select ref="returnerSelect" @select="selectReturner"/>
  </el-dialog>
</template>

<script>
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import ToolSelect from "@/views/information/ToolManagement/Tool/ToolSelect";
  export default {
    name: "ToolRequisitionBillEdit",
    components: {ToolSelect, UserSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        disabled:false,
        model: {
          pkid: "",
          billNo: "",
          toolId: "",
          toolName: "",
          note: "",
          status: "",
          receiverId: "",
          receiverName: "",
          receiveTime: "",
          returnerId: "",
          returnerName: "",
          returnTime: "",
          creatorId: "",
          creatorName: "",
          createTime: "",
        },
        ruleValidate: {
          toolName: { required: true, message: "不能为空", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          this.getData(row.pkid);
        }else {
          this.getNode();
        }
      },
      getData(pkid) {
        this.$http.get("basic", `toolRequisitionBills/${pkid}`).then((res) => {
          console.log(res);
          if (res.success) {
            this.model = Object.assign(this.model, res.data);
          }
        });
      },
      getNode() {
        this.$http.get("basic", "toolRequisitionBills/selectNo").then((resp) => {
          console.log(resp);
          if (resp.success) {
            this.model.billNo = resp.data;
          }
        });
      },
      selectTool(row) {
        console.log(row);
        this.model.toolId = row.pkid;
        this.model.toolName = row.toolName;
      },
      selectReceiver(row) {
        console.log(row);
        this.model.receiverId = row.systemUserID;
        this.model.receiverName = row.employeeName;
      },
      selectReturner(row) {
        console.log(row);
        this.model.returnerId = row.systemUserID;
        this.model.returnerName = row.employeeName;
      },

      handleSubmit() {
        if (this.model.pkid > 0) {
          this.handleSubmitPut();
        } else {
          this.handleSubmitPost();
        }
      },
      handleSubmitPut() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "toolRequisitionBills", this.model)
              .then((resp) => {
                this.submitLoading = false;
                this.dialogVisible = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitPost() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "toolRequisitionBills", this.model)
              .then((resp) => {
                this.submitLoading = false;
                this.dialogVisible = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
